import { getOfficialWebsiteUrl } from "./utils";

/**
 * 服务支付协议
 */
export const ServicePaymentAgreementUrl =
  getOfficialWebsiteUrl() + "/document/payment-agreement";

export const AliPayId = "ALIPAY_PAY_ID";

export enum ResponseCode {
  Success = 200,
}
